export enum SequenceType
{
    OutboundBolNumber = 1,
    InboundBolNumber = 2
}
